 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];


 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 	};


 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		38: 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		38: 0
 	};



 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"styles","6":"vendors~GDPRPrompt~PlaylistPage~PlaylistWrapped~teamGmTools~teamScores~teamSquads","7":"vendors~GamePage~PlaylistPage~PlaylistWrapped~TeamPage~scheduleWidget","8":"GDPRPrompt","9":"vendors~GDPRPrompt","10":"vendors~GamePage-Details~userHandOfGodInspector~userHeader","11":"vendors~GamePage~TeamPage~userHeader","14":"vendors~GamePage~WidgetCreatorsPage","15":"vendors~UserWidgetsPage~ssUiPremiumWidgetSubscriptions","16":"vendors~teamNoMatch~userHandOfGodInspector","17":"EmbedHeader","18":"FrontPage","19":"GamePage","20":"GamePage-Chat","21":"GamePage-Details","22":"GamePage-Fans","23":"GamePostPage","24":"HandOfGod","25":"HeaderFrontPage","26":"Internal-NotificationsPage","27":"Internal-SystemMetricsPage","28":"InternalPage","29":"NoMatchPage","30":"NotificationsPage","31":"PlaylistPage","32":"PlaylistWrapped","33":"TeamPage","34":"UpdateGameModal","35":"UserPage","36":"UserWidgetsPage","37":"WidgetCreatorsPage","39":"cachedLevelsOfPlay","40":"logosAndSponsors","41":"scheduleWidget","42":"ssTeamScheduleWidget","43":"ssUiGameVenue","44":"ssUiPremiumWidgetSubscriptions","45":"ssUiTeamOverrideManager","46":"ssUiTeamScheduleWidget","47":"ssUiTeamVenueManager","48":"ssUiTrendingList","49":"ssUiVenueTypeToFind","50":"teamChat","51":"teamFans","52":"teamGames","53":"teamGmTools","54":"teamMain","55":"teamMedia","56":"teamNoMatch","57":"teamScheduleCreator","58":"teamScheduleCreatorForm","59":"teamScores","60":"teamSquads","61":"userEdit","62":"userEditCommunicationSettings","63":"userFollowers","64":"userFollowing","65":"userHandOfGodInspector","66":"userHeader","67":"userMedia","68":"userPage","69":"userTeams","70":"vendors~FrontPage","71":"vendors~GamePage-Fans","72":"vendors~Internal-NotificationsPage","73":"vendors~Internal-SystemMetricsPage","74":"vendors~NotificationsPage","75":"vendors~UserWidgetsPage","76":"vendors~scheduleWidget","77":"vendors~userEditCommunicationSettings","78":"vendors~userHandOfGodInspector"}[chunkId]||chunkId) + "." + {"0":"088f9073c8444866418f","1":"86f1f25c4c35ce75012b","2":"f741bd23d840de3d4d7a","3":"50344c817fba4d2b74e9","4":"5958c0e528a868e05ad2","5":"b18141140f62ac4e3a1d","6":"8bf9f811cacf371b286b","7":"adc63b2b36013adfb1c0","8":"759116028cac6606516b","9":"1292d3c45ffcd8208237","10":"7215e1315399c5f14bb3","11":"1ce00bb834dcbe4890e8","12":"d4398a4fcd011bee78fd","13":"ca624aaf6a6d2a83d241","14":"623037597ca786dfb0d2","15":"b51aad4e2ebdcf0184e9","16":"a68986fea5cc8ed9a2a4","17":"162e38fb014dc11f5596","18":"50f1621342b771b70120","19":"d6bfd885050fbdc60de9","20":"d0242166e74a866cab4a","21":"b76d5491a4fd781f4def","22":"6ea228cb2b8553ad9ec2","23":"c6f81c4d2039e7127490","24":"18170fbd85b54df5ac86","25":"bb6c85720471ebf279a7","26":"7ae2f115ece7d36a6c99","27":"5968500cb76489a3031d","28":"14781268bfcfc9d2e9e9","29":"5bd8a087ea3f4070c2f4","30":"bc689ee75804b1fe1cc5","31":"4625de19b9e25d1671f2","32":"4093a69ed8a7d65cf7b1","33":"0a494403a922dd6cd524","34":"aa3d838bb9463d15952b","35":"ee799d1eb1c87c427e18","36":"d641b4d130b99e7979e4","37":"5ef2521fa8016e168e7a","39":"2ed50e20667db2d60673","40":"bc7ec7eb13d8e0f0b9f9","41":"a9a19fa76462b2c8e81d","42":"3422256b9cd492167506","43":"c8eacafaa9ce46d69b36","44":"36c308a8dfd8d0f346ab","45":"d67c2ddcbcf8efb8efca","46":"aea686005f710110721b","47":"d249f951ce0d2b6381a2","48":"9a5409a100e5517cd5e7","49":"ef98c5b0c49b094527eb","50":"17f742cff5fe3d07e1d8","51":"83e8e92328b9b19b8527","52":"b2311b6d2d247a2addcf","53":"4bcc547508f846c4f9c8","54":"f82ba459fbbf71bd95bb","55":"42a6e02b2985cd5d2b6b","56":"64866a1ada44c8db794a","57":"045220953379a2c62241","58":"cd2d50311d0a32cabee5","59":"7237efa2de1965e99280","60":"14a9b728072a427ec44f","61":"c9ddd1a992bcc1f02b5f","62":"a0b57929c1a61c87e9fd","63":"b0d61f49d69eb51d35e3","64":"7d4f23859435dc2551bd","65":"93f47edd5fc0fe317fd3","66":"52e7948ec8e4151bf769","67":"4bf29164108bbdcff373","68":"83d6b3b321b93c45980c","69":"5268ba2be54d9ca91795","70":"897de08256c35e3cb49e","71":"22256209f3bb726d7533","72":"726b6d340f4181da2771","73":"4d10eb4548b1db3ab71c","74":"acd7d959ec84ae3cc793","75":"9c4ef096534318bc1bc5","76":"0f756b1db33d20b32c75","77":"167058795fe7ac58ac6c","78":"696d16cb65e958cfb768","79":"934cf6d301464d588fc3","80":"06be88d24bbfef1a6bd8","81":"e35edba92a063f5196b6","82":"fbfd9cd097f10aa0fa72","83":"58c1c40dd1b383881ed5","84":"0a9ad9bb1cee2eca14cc","85":"e09ef3283034d8af64ca","86":"9f01d6239f95992f4b1b","87":"d4c289b55855d385abde","88":"02018f9c6eb08d515501","89":"9c283c495750f4361696","90":"51367a29e0bdb16e57e0"}[chunkId] + ".chunk.js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"0":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + chunkId + ".extractedFromBundle." + "1c37a9c84c8ab37e918b" + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "realtime/app";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["ssuiWebpackJsonp"] = window["ssuiWebpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// Load entry module and return exports
 	return __webpack_require__(__webpack_require__.s = 823);
